import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PricingSection from "./components/PricingSection";
import Footer from "./components/Footer";
import ParallaxBannerSection from "./components/ParallaxBannerSection"
import LocationSection from "./components/LocationSection";
import Navbar from "./components/Navbar";
import ContactSection from "./components/ContactSection"
import GifShowcaseSection from "./components/GifShowcaseSection";

function App() {
  return (
    <div className="font-sans bg-brandLight">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ParallaxBannerSection />
        <PricingSection />
        <GifShowcaseSection />
        <ContactSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;